<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: PingFangSC-Regular, PingFang SC;
  color: #333;
}
</style>
 